import { faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Icon } from '@/components/ui/icon.component';

type ResultOptionProps = {
  description: string;
  callback: () => void;
};

export const ResultOption = ({ description, callback }: ResultOptionProps) => {
  return (
    <Button
      variant="text"
      className="justify-start items-center gap-1 hover:text-green-500 group cursor-pointer"
      onClick={callback}
      data-testid={DataTestIdEnum.LOCATION_RESULT_OPTION}
    >
      <div className="size-5 shrink-0 flex items-center justify-center">
        <Icon icon={faLocationDot} className="text-gray-400 text-base group-hover:text-green-500" />
      </div>
      <p className="text-gray-600 text-left font-medium leading-5 text-wrap group-hover:text-green-500">
        {description}
      </p>
    </Button>
  );
};
